export default {"src":"/_next/static/media/FileAvatar.eaa049ed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};